"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefixedSessionStorage = void 0;
/**
 * Implements proxy for a [[ParsecSessionStorage]] that adds prefix to all keys when storing and retrieving data.
 * Convenient to join several storages in one separating their namespaces. Use it with some existing one. Data
 * are stored in parent storage.
 *
 * like [[LocalSessionStorage]].
 */
class PrefixedSessionStorage {
    /**
     * Create proxy storage that keeps data in the parent storage adding specified prefix to all keys.
     * @param prefix string to add to all keys
     * @param storage parent storage where the data is actually stored.
     */
    constructor(prefix, storage) {
        this.prefix = prefix;
        this.storage = storage;
    }
    getItem(key) {
        return this.storage.getItem(this.prefix + key);
    }
    removeItem(key) {
        this.storage.removeItem(this.prefix + key);
    }
    setItem(key, value) {
        this.storage.setItem(this.prefix + key, value);
    }
}
exports.PrefixedSessionStorage = PrefixedSessionStorage;
//# sourceMappingURL=PrefixedSessionStorage.js.map